import { styled } from '@frontend/theme';
import { Box as MUIBox } from '@mui/material';
import { ContainerTrackingDataWrapperProps } from './ContainerTracking.types';

export const ContainerTrackingWrapper = styled(MUIBox)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '60px',
  alignItems: 'flex-start',
  width: '100%',
  height: '100%',
  paddingBottom: '24px',
  [theme.breakpoints.down('tabletL')]: {
    flexDirection: 'column',
  },
}));

export const ContainerTrackingDetailsWrapper = styled(MUIBox)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '24px',
  width: '100%',
});

export const ContainerTrackingDataWrapper = styled(MUIBox, {
  shouldForwardProp: prop => prop !== 'route',
})<ContainerTrackingDataWrapperProps>(({ theme, route }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '16px',
  width: '100%',
  [theme.breakpoints.up('tabletL')]: {
    width: route.length > 0 ? '100%' : '50%',
  },
}));

export const EmptyContainerTrackingWrapper = styled(MUIBox)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '12px',
  alignItems: 'flex-start',
  padding: '8px 16px',
  width: '100%',
  backgroundColor: theme.palette.tertiary[500],
  '& > svg': {
    minWidth: '24px',
  },
}));
